const IS_LOADING = "campaigns/showFailures/showFailureSpotStatus/IS_LOADING";
const SHOWFAILURE_SPOTSTATUS_DATA = "campaigns/showFailures/showFailureSpotStatus/FAILURE_DATA";
const IS_ERROR = "campaigns/showFailures/showFailureSpotStatus/IS_ERROR";
const FILTER = "campaigns/showFailures/showFailureSpotStatus/FILTER";

export { IS_LOADING, SHOWFAILURE_SPOTSTATUS_DATA, IS_ERROR, FILTER };
